module.exports = __webpack_public_path__ + "img/sr3_slide_1.5c53df1f.jpg";